import React, { memo, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { COLOR } from '@/globalStyles';

interface IComponentDisablerProps {
    className?: string;
    isDisabled?: boolean;
    children: ReactNode;
    transparent?: boolean;
    bgColor?: string;
}

const ComponentDisabler = ({ className, children }: IComponentDisablerProps) => {
    return <div className={className}>{children}</div>;
};

const Memoized = memo(ComponentDisabler);
const Styled = styled(Memoized)`
    ${({ isDisabled, transparent = true, bgColor }) =>
        isDisabled &&
        css`
            position: relative;
            &:before {
                z-index: 10;
                content: '';
                cursor: not-allowed;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                ${transparent
                    ? `background-color: ${COLOR.transparentWhite}`
                    : bgColor
                    ? `background-color: ${bgColor}`
                    : ''}
            }
        `}
`;

export default Styled;
